export default "__VITE_ASSET__67253adf__"